import { BettingOddsTypeInterface } from "../Interfaces/globalContextInterface";

export const oddsTypes: BettingOddsTypeInterface[] = [
	{ id: 1, name: "American Odds", value: "american", active: true },
	{ id: 2, name: "Decimal Odds", value: "decimal", active: false },
];
